import { Box, Skeleton, Tab, Tabs } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ICategory } from "../interfaces/ICategory";
import { dummyArray } from "../utils/dummy";
type INavbar = {
  categories: ICategory[];
  slug: string;
  isLoading:boolean
};
const NavBar: React.FC<INavbar> = ({ categories, slug,isLoading }) => {
  const navigation = useNavigate();
  const [value, setValue] = React.useState<string>((slug as string) ?? undefined);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleClick = (slug: string) => {
    navigation(`/category/${slug}`);
  };

  return (
    <Box
      className="shadow hidden lg:block xl:block md:block "
      p={0}
      pl={2}
      pr={2}
      sx={{mb:'2px'}}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="navbar-tabs"
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {isLoading &&
          dummyArray.map((item) => (
            <Tab
              key={item}
              label={
                <Skeleton
                  variant="text"
                  sx={{ ml: 1 }}
                  height={30}
                  width={115}
                />
              }
            />
          ))}
        {!isLoading &&
          categories.map((category) => (
            <Tab
              key={category.id}
              value={category.slug}
              label={category.name}
              onClick={() => handleClick(category.slug)}
            />
          ))}
      </Tabs>
    </Box>
  );
};
export default NavBar;
